import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/lib/seo";

export default function NotFoundPage() {
  useSeo({ title: "Page not found | GrabNChat", description: "The page you are looking for doesn't exist or has moved.", noindex: true });
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center">
        <p className="font-display text-7xl font-bold text-slate-900">404</p>
        <h1 className="mt-3 font-display text-2xl font-bold text-slate-900">Page not found</h1>
        <p className="text-slate-600 mt-2 max-w-md">The page you’re looking for doesn’t exist or has moved.</p>
        <Link to="/">
          <Button className="mt-6 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full px-6 h-11 font-semibold" data-testid="notfound-home-btn">
            Back to Home
          </Button>
        </Link>
        <p className="mt-6 text-sm text-slate-600">Popular pages: <Link to="/features" className="font-semibold text-[#25D366]">Features</Link> · <Link to="/pricing" className="font-semibold text-[#25D366]">Pricing</Link> · <Link to="/products/whatsapp-business-api" className="font-semibold text-[#25D366]">WhatsApp Business API</Link> · <Link to="/contact" className="font-semibold text-[#25D366]">Contact</Link></p>
      </div>
    </div>
  );
}
